import React from 'react'
import ReactDOM from 'react-dom'
import 'ress'

import App from './App'
import * as serviceWorker from './serviceWorker'

process.env.NODE_ENV !== 'development' && (console.log = () => {})

ReactDOM.render(
  <App />,
  document.getElementById('root'),

  // e => {
  //   console.log("callback")
  // }
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
